import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@trillion/ui/theme/theme-provider";
import { AppAuthProvider } from "@trillion/auth";
import { Toaster } from "@trillion/ui/components/ui/sonner";
import { getEnv } from "@trillion/ui/lib/env";

export function RootLayout() {
  return (
    <ThemeProvider>
      <AppAuthProvider authUrl={getEnv("PASSPORT_API_URL")} product="passport" clientVariant="web">
        <div className="antialiased">
          <Outlet />
          <Toaster />
        </div>
      </AppAuthProvider>
    </ThemeProvider>
  );
}
